import React from "react";
import { useState } from "react";
import { useCallback } from "react";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import StepContent from "@mui/material/StepContent";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import StatusIcon from "../../Assests/Images/Status.png";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import Sdf from "../SelfDeclarationForm/Sdf";
import { useEffect } from "react";
import { selectUser } from "../../redux/modules/userSlice";
import { useSelector } from "react-redux";
import { toast } from 'react-toastify';
import { UserAPI } from "../api";

function FormStatusPanel(props) {

  const currentPath = useLocation().pathname;
  const split = currentPath.split('/');
  const navigate = useNavigate();
  const [pendingStatus, setPendingStatus] = useState(0);
  const [activeStep, setActiveStep] = useState(0);
  const isIncompleteStatus = (status) =>
    status === "pending" || status === "draft" || status === "resubmission required";

  const params = useParams();
  // const splitURL =split[split.length - 1] ?  split.slice(1,).join('/') :''
  const id = split[split.length - 1] ? split[split.length - 1] : "";
  const urlIDMatch = split[split.length - 1] ?  split.slice(1,).join('/') :''
  const { user } = useSelector(selectUser);
  const isAdmin = user.isAdmin;
  const isValidObjectId = /^[a-f\d]{24}$/i.test(id);
  const [menuOptions, setMenuOptions] = useState([
    {
      name: 'New Joinee Form',
      description: user.isNewJoineeFormComplete,
      link: isAdmin ? `/AdminNewJoineeForm/${id}` : '/new-joinee'
    },
    {
      name: 'Self Declaration',
      description: user.isSelfDecalrationFormComplete,
      link: isAdmin ? `/AdminSDF/${id}` : '/sdf'
    },
    {
      name: 'EPF',
      description: user.isEPFFormComplete,
      link: isAdmin ? `/AdminEPF/${id}` : '/epf'
    },
    {
      name: 'Form 11',
      description: user.isForm11Complete,
      link: isAdmin ? `/AdminForm11/${id}` : '/form11'
    },
    {
      name: 'Form F',
      description: user.isFormFComplete,
      link: isAdmin ? `/AdminFormF/${id}` : '/formf'
    },
    {
      name: 'Form Q',
      description: user.isFormQComplete,
      link: isAdmin ? `/AdminFormQ/${id}` : '/formq'
    },
    {
      name: 'NDA',
      description: user.isNDAFormComplete,
      link: isAdmin ? `/AdminNda/${id}` : '/nda'
    }
  ]);

  const sidebarChangeHandler =  ()=>{
    const menuIndex = menuOptions.findIndex((e,i)=>{
       if(!urlIDMatch ){
          return e.link
       }
      return e.link ===  "/"+urlIDMatch 
    })
    setActiveStep(menuIndex);
  };

  
 

  useEffect(() => {
    let tempStep = 9;
    menuOptions.forEach((menu, index) => {
      if (!isAdmin && tempStep === 9 && isIncompleteStatus(menu.description)) {
        tempStep = index
      } else if (isAdmin) {

        if (currentPath.includes('AdminNewJoineeForm')) tempStep = 0;

        else if (currentPath.includes('AdminSDF')) tempStep = 1;

        else if (currentPath.includes('AdminEPF')) tempStep = 2;

        else if (currentPath.includes('AdminForm11')) tempStep = 3;

        else if (currentPath.includes('AdminFormF')) tempStep = 4;

        else if (currentPath.includes('AdminFormQ')) tempStep = 5;

        else if (currentPath.includes('AdminNda')) tempStep = 6;
      }
    });
    setActiveStep(tempStep);
    sidebarChangeHandler()
  }, [urlIDMatch]);

  const onSidebarMenuChange = (index) => {
    let tempObj = { ...menuOptions[index] };
    let allComplete = menuOptions.filter((e, i) => i < index && isIncompleteStatus(e.description))

    // Joinee can open any form. Admin review flow keeps sequential gate.
 setActiveStep(index);
      navigate(tempObj.link);

  };

  const loadMenuOptions = useCallback(() => {
    if (user.isAdmin && !isValidObjectId) return;

    UserAPI.getUser(user.isAdmin ? id : user._id)
      .then((res) => {
       setMenuOptions([
          {
            name: 'New Joinee Form',
            description: res.data ? res.data.isNewJoineeFormComplete  :'',
            link: isAdmin ? `/AdminNewJoineeForm/${id}` : '/new-joinee'
          },
          {
            name: 'Self Declaration',
            description: res.data ? res.data.isSelfDecalrationFormComplete : '',
            link: isAdmin ? `/AdminSDF/${id}` : '/sdf'
          },
          {
            name: 'EPF',
            description: res.data ? res.data.isEPFFormComplete : '',
            link: isAdmin ? `/AdminEPF/${id}` : '/epf'
          },
          {
            name: 'Form 11',
            description: res.data ? res.data.isForm11Complete : '',
            link: isAdmin ? `/AdminForm11/${id}` : '/form11'
          },
          {
            name: 'Form F',
            description: res.data ? res.data.isFormFComplete : '',
            link: isAdmin ? `/AdminFormF/${id}` : '/formf'
          },
          {
            name: 'Form Q',
            description: res.data ? res.data.isFormQComplete : '',
            link: isAdmin ? `/AdminFormQ/${id}` : '/formq'
          },
          {
            name: 'NDA',
            description: res.data ? res.data.isNDAFormComplete :'',
            link: isAdmin ? `/AdminNda/${id}` : '/nda'
          }
        ])
      });
  }, [id, isAdmin, isValidObjectId, user._id, user.isAdmin]);


  useEffect(()=>{
    loadMenuOptions();
   
  },[urlIDMatch, loadMenuOptions])

  useEffect(() => {
    const refreshFormStatus = () => loadMenuOptions();
    window.addEventListener("formStatusChanged", refreshFormStatus);
    return () => window.removeEventListener("formStatusChanged", refreshFormStatus);
  }, [loadMenuOptions]);

  return (
    <div className="">
      <div
        className="position-fixed pt-5 px-2 border"
        style={{ background: "#ECF4FD", height: "100vh", top: "65px" }}
      >
        <Box sx={{ paddingLeft: "15px", paddingRight: "10px", maxWidth: "500px" }}>
          <Stepper activeStep={activeStep} orientation="vertical">
            {menuOptions.map((item, index) => (
              <Step key={item.name} >
                <StepLabel>
                  <button
                    type="button"
                    style={{ border: "none", background: "none" }}
                    onClick={() => onSidebarMenuChange(index)}
                  >
                    {item.name}
                  </button>
                </StepLabel>
                <StepContent>
                  <Typography
                    style={{ display: "flex", flexDirection: "row" }}
                    sx={{ fontSize: "12px" }}
                  >
                    <img className="img-fluid" src={StatusIcon} />
                    <div
                      style={{ border: "none", background: "none" }}
                      sx={{ mt: 1, mr: 1 }}

                    >
                      {item.description}
                    </div>
                  </Typography>
                  <Box sx={{ mb: 2 }}>
                  </Box>
                </StepContent>
              </Step>
            ))}
          </Stepper>
        </Box>
      </div>
    </div>
  );
}

export default FormStatusPanel;


